import type { FaireProductEntity } from "../../entity_types/product";

export const p_3a77znjm9c: FaireProductEntity = {
  token: "p_3a77znjm9c",
  type: "product",
  name: "Sam Bunny- Organic Fine Knit Stuffed Animal Baby Toy",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/9c76dbc989e299eb50f3bdd61e7fc49a67b2b453b2625e22e90748c3f90aff2c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/602f9f26d8903dfc63159bd4b5745d150557fa6dc4de6a21a51878df557407b2.jpeg",
    "https://cdn.faire.com/fastly/aaed755cf59cf267d99755c41c68cd8beaf41304aaf3e2215a918aa237c36581.jpeg",
    "https://cdn.faire.com/fastly/7e71c77c61f3e8af5a82755f8229fd0ea51b4d1d972355c91c245db001b3557b.jpeg",
    "https://cdn.faire.com/fastly/7beeb021c5888147d6823c82cd500e707a8acbc1f117158769f39ea3a05e05eb.jpeg",
    "https://cdn.faire.com/fastly/f9ba3749e1c9c1c4a709bfe181c0b41e645d0d038ea78478966ce5d3f1c1e13b.jpeg",
    "https://cdn.faire.com/fastly/14d84d66ddd78d1f82b3a2b16fff71f32f4f1ef90a63d1455a22690ae3722b69.jpeg",
    "https://cdn.faire.com/fastly/79e57fbe2ba9db8f0a6bd3ab5f7c74e7a776992cd6bd7aa685cff05d18fe35e4.jpeg",
    "https://cdn.faire.com/fastly/6e25ef7bff82ac54083f1b2c950d33c3908d02add49729ce9d234d8ff6bf0424.jpeg",
    "https://cdn.faire.com/fastly/ebfd6d84f66adacf2a0274c78b2554ad125a0d47a0780f9c481b1f87ded1ab77.jpeg",
  ],
  priceDollars: 20,
  description:
    'Sam, the Bunny Gardener, is a sweet and loyal friend. Sam loves nature and enjoys hopping around in her garden.\n100% organic cotton outer shell, and poly-fill on the inside.\nSize: 13" x 7"\nWeight: 5 oz\nFor babies, kids & adults, 8 months and up.\n\nViverano Organic Toys:\nQuirky & cuddly collection of organic cotton knit toys for your precious little ones.\nFresh & imaginative designs to bring joy and wonder to babies, kids and even adults.\nGreat for buddy adventures, good company and bedtime snuggles.\nLovingly made by hand using certified organic cotton, safe for hugging & snuggling.\nHeirloom quality, meticulous construction and attention to detail.\nNon-toxic and eco-friendly materials.\nSlight color variations & imperfections may exist making each handmade piece charming and one-of-a-kind.\nEasy care machine washable with cool water and non-toxic detergent, fluff in the dryer for a few minutes and then air dry.\nEthically handcrafted by artisans at a GOTS certified facility in India.',
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:32.981Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
